<template>
  <div class="container mt-4">
    <div class="card bg-white bg-opacity-90 mb-3">
      <div class="card-body py-2 px-3">
        <h1 class="mb-0 text-start">Tillage Implements</h1>
      </div>
    </div>
    <div class="row">
      <div
        v-for="item in tillageImplements"
        :key="item.id"
        class="col-12 col-md-6 mb-4"
      >
        <TillageImplement
          :title="item.name"
          :description="item.description"
          :details="item.details"
          :images="item.images"
          :illustration="item.illustration"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TillageImplement from "@/components/activity/TillageImplement.vue";
import TillageImplementData from "@/data/tillageImplementData.json";

export default {
  name: "TillageImplementsView",
  data() {
    return {
      tillageImplements: TillageImplementData.implements
    };
  },
  components: {
    TillageImplement
  }
};
</script>
